// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let ClientPropertyLocation_property_graphql = require("../../../__generated__/ClientPropertyLocation_property_graphql.bs.js");
let ClientPropertyLocation_propertyLocation_graphql = require("../../../__generated__/ClientPropertyLocation_propertyLocation_graphql.bs.js");

let convertFragment = ClientPropertyLocation_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ClientPropertyLocation_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ClientPropertyLocation_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ClientPropertyLocation_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ClientPropertyLocation_property_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = ClientPropertyLocation_propertyLocation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ClientPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ClientPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ClientPropertyLocation_propertyLocation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ClientPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

let PropertyLocationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ClientPropertyLocation$Address(props) {
  let locationDisplay = props.locationDisplay;
  let address = props.address;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: address !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              children: address
            }),
            JsxRuntime.jsx("div", {
              children: locationDisplay,
              className: "text-lg text-zinc-600"
            })
          ]
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              children: locationDisplay
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(IconV5.make, {
                    icon: "lock",
                    size: 16,
                    className: "text-zinc-600"
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Hidden Address"
                  })
                ],
                className: "flex flex-row items-center gap-1 lg:before:content-['('] lg:after:content-[')']"
              }),
              className: "text-xl text-zinc-600"
            })
          ]
        }),
      className: "flex flex-col lg:flex-row items-baseline gap-2"
    }),
    className: "text-zinc-700 font-medium text-2xl sm:text-3xl"
  });
}

let Address = {
  make: ClientPropertyLocation$Address
};

function ClientPropertyLocation$ByPropertyLocation(props) {
  let propertyLocation = RescriptRelay_Fragment.useFragment(ClientPropertyLocation_propertyLocation_graphql.node, convertFragment$1, props.propertyLocation);
  switch (propertyLocation.__typename) {
    case "PropertyLocationWithHiddenAddress" :
      return JsxRuntime.jsx(ClientPropertyLocation$Address, {
        address: undefined,
        locationDisplay: propertyLocation.locationDisplay
      });
    case "PropertyLocationWithVisibleAddress" :
      return JsxRuntime.jsx(ClientPropertyLocation$Address, {
        address: propertyLocation.address,
        locationDisplay: propertyLocation.locationDisplay
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected property location ` + propertyLocation._0);
  }
}

let ByPropertyLocation = {
  make: ClientPropertyLocation$ByPropertyLocation
};

function ClientPropertyLocation$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(ClientPropertyLocation_property_graphql.node, convertFragment, props.property);
  return JsxRuntime.jsx(ClientPropertyLocation$ByPropertyLocation, {
    propertyLocation: property.propertyLocation.fragmentRefs
  });
}

let WithoutErrorBoundary = {
  make: ClientPropertyLocation$WithoutErrorBoundary
};

function ClientPropertyLocation(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "location",
    children: JsxRuntime.jsx(ClientPropertyLocation$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let make = ClientPropertyLocation;

exports.PropertyFragment = PropertyFragment;
exports.PropertyLocationFragment = PropertyLocationFragment;
exports.Address = Address;
exports.ByPropertyLocation = ByPropertyLocation;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* IconV5 Not a pure module */
